class ArnSignIn extends HTMLElement {
    constructor() {
        super();

        this.elms = {
            input: this.querySelector("input"),
            button: this.querySelector("button"),
        };
        this.template = this.querySelector("template").content.cloneNode(true);
        this.elms.input.addEventListener("change", this.onInputChange.bind(this));
        this.elms.button.addEventListener("click", this.onButtonClick.bind(this));
    }

    onInputChange(e) {
        const { input } = this.elms;
        if (input.value.length == 0) {
            this.querySelector(".results-inner").hidden = true;
            return;
        }
    }

    onButtonClick(e) {
        const { input } = this.elms;
        if (input.value.length == 0) {
            this.querySelector(".results-inner").hidden = true;
            return;
        }

        fetch("/apps/toolbox/api/customers/exists", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email: input.value.trim() }),
        })
            .then((res) => res.json())
            .then((resJSON) => {
                const icon = this.template.querySelector(`.template-icon ${resJSON.exists ? ".success" : ".fail"}`);
                const text = this.template.querySelector(`.template-text ${resJSON.exists ? ".success" : ".fail"}`);
                const button = this.template.querySelector(`.template-button ${resJSON.exists ? ".success" : ".fail"}`);

                this.classList.remove("is-success", "is-error");
                this.classList.add(resJSON.exists ? "is-success" : "is-error");
                this.querySelector(".results-icon").innerHTML = icon.innerHTML;
                this.querySelector(".results-email").innerHTML = input.value.trim();
                this.querySelector(".results-text").innerHTML = text.innerHTML;
                this.querySelector(".redirect-button").innerHTML = button.innerHTML;
                this.querySelector(".redirect-button").href = resJSON.exists ? "https://shopify.com/62216765596/account" : "/pages/register";
                this.querySelector(".results-inner").hidden = false;
            });
    }
}

customElements.define("arn-sign-in", ArnSignIn);
